// Copyright (c) 2025 DTCC and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { useExerciseSubmission } from '@hooks/mutations/ledger/useSubmission';
import {
  ParticipantService,
  ParticipantService_RequestEndInvestorOnboarding,
} from '@daml.js/dtc-registry-app/lib/Dtc/Registry/App/V3/Service/Participant';
import { ContractId } from '@daml/types';
import {
  ERR_REQUEST_END_INVESTOR_ONBOARDING,
  SUC_REQUEST_END_INVESTOR_ONBOARDING,
} from '../../../../utils/strings';

interface Args {
  participantServiceContractId: string;
  participantId: string;
  endInvestorId: string;
  upgrader: string;
}

export const useRequestEndInvestorOnboarding = () => {
  const { submit: requestEndInvestorOnboarding } = useExerciseSubmission(
    ParticipantService.ParticipantService_RequestEndInvestorOnboarding,
    SUC_REQUEST_END_INVESTOR_ONBOARDING,
    ERR_REQUEST_END_INVESTOR_ONBOARDING,
  );

  return async (args: Args) => {
    const { participantServiceContractId, endInvestorId, upgrader } = args;

    const payload: ParticipantService_RequestEndInvestorOnboarding = {
      endInvestor: endInvestorId,
      upgrader,
      extraArgs: {
        context: { values: {} },
        meta: { values: {} },
      },
    };

    await requestEndInvestorOnboarding({
      cid: participantServiceContractId as ContractId<ParticipantService>,
      argument: payload,
    });
  };
};
